import MainLayout from '../../../../shared/Layouts/MainLayout'
import css from './equipmentModels.module.css'
import NavigationBreadcrumbs from '../../../../navigation/components/NavigationBreadcrumbs'
import EquipmentModelsTable from './components/EquipmentModelsTable'
import BadgeCount from '../../../../shared/Badges/BadgeCount'
import Button from '../../../../shared/Buttons/Button'
import { useRecoilValue } from 'recoil'
import equipmentModelsAtom from './equipmentModels.atom.ts'
import { useState } from 'react'
import CreateEquipmentModelSidePage from './components/CreateEquipmentModelSidePage'
import PlusIcon from '../../../../assets/icons/plus.svg?react'
import ProtectedContent from '@/services/rights/ProtectedContent'
import useTitle from '@/shared/hooks/useTitle'

const EquipmentModels = () => {
  useTitle('Модели оборудования')
  const [createPageOpen, setCreatePageOpen] = useState(false)
  const models = useRecoilValue(equipmentModelsAtom).items

  return (
    <MainLayout>
      <div className={css.wrapper}>
        <div className="flex-lines gap16 height100">
          <NavigationBreadcrumbs />
          <div className="flex-lines gap4">
            <h2 className="text-heading-3">Конфигурация оборудования</h2>
          </div>
          <div className={css.mainCard}>
            <div className="inline-flex-gap gap24 center">
              <div className="inline-flex-gap gap8 center">
                <h2 className="text-heading-4">Модели оборудования</h2>
                <BadgeCount type="default" count={models.length} />
              </div>
              <ProtectedContent
                requiredRight="equipment:create"
                fallBack={
                  <span className="text-nm text-description">
                    Для добавления новой модели обратитесь к администратору системы
                  </span>
                }
              >
                <Button
                  size="default"
                  type="primary"
                  text="Создать модель"
                  icon={<PlusIcon className="text-white" />}
                  onClick={() => setCreatePageOpen(true)}
                />
              </ProtectedContent>
            </div>
            <EquipmentModelsTable />
          </div>
        </div>
      </div>
      <CreateEquipmentModelSidePage open={createPageOpen} onClose={() => setCreatePageOpen(false)} />
    </MainLayout>
  )
}

export default EquipmentModels
